export const fallbackLocation = {
  latitude: 37.54666563187861,
  longitude: 126.98225129089356,
};

export const GEOLOCATION_TIMEOUT_MS = 2500;
export const GEOLOCATION_MAX_AGE_MS = 60 * 1000;

// 한 화면에 있는 곳을 전부 받는다. 서울 도심은 1,000곳이 넘는다(을지로입구 600m 안 1,183곳).
// 100 이던 동안 지도는 그 8분의 1만 그렸고, 확대할 때마다 없던 가게가 튀어나왔다.
// 서버도 같은 값까지 준다(MAP_PINS_MAX_RESULTS). 응답에서 지도가 안 쓰는 칸을 뺐기 때문에
// 개수가 14배가 되어도 크기는 그만큼 늘지 않는다(을지로입구 1,414곳 226KB).
// 2000 으로 올렸다가 800 으로 낮춘다 — 사장님 자리에서 드래그가 끊긴다는 보고가 있었다.
// 800 이어도 예전(100)의 8배다. 매끄러운 것을 확인한 뒤 다시 올릴 수 있다.
// 800 → 400: 사장님 크롬이 WebGL 하드웨어 가속을 못 쓴다(Software only). 그 환경에서는
// 묶음 라벨이 많을수록 지도가 무거워진다. 400 이어도 예전(100)의 4배다.
export const MAP_PIN_SEARCH_LIMIT = 400;
export const MAP_PIN_CACHE_TTL_MS = 60 * 1000;
export const MAP_PIN_CACHE_MAX_ENTRIES = 80;
export const MAP_PIN_BOUNDS_PRECISION = 4;
